export const mutations = {
  SET_OCR_BOX_INFO (state, info) {
    state.ocrBoxInfo = info;
  },
  SET_BUSINESS_LICENSE_IMAGE(state, info) {
    state.businessLicenseImage = info;
  },
  SET_BUSINESS_LICENSE_INFO(state, info) {
    state.businessLicenseInfo = info;
  },
  SET_USER_INFO(state, info) {
    state.userInfo = info;
  },
  RESET_ALL_INFO(state) {
    state.businessLicenseImage = [];
    state.businessLicenseInfo = {};
    state.userInfo = {};
  }
};
